module.exports = __webpack_public_path__ + "static/media/javaScript.e97f8736.webp";